import { useEffect, useState } from 'react';
import { API_BASE } from '../config/api';

// Whether the signed-in user may open /dashboard/analytics (Header + Dashboard).
export default function useAnalyticsAccess(user) {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (!user?.token) {
      setAllowed(false);
      return undefined;
    }
    let cancelled = false;
    fetch(`${API_BASE}/api/analytics/access`, {
      headers: { Authorization: `Bearer ${user.token}` },
    })
      .then(async (r) => {
        const data = r.ok ? await r.json().catch(() => ({})) : {};
        if (!cancelled) setAllowed(Boolean(data?.allowed));
      })
      .catch(() => {
        if (!cancelled) setAllowed(false);
      });
    return () => {
      cancelled = true;
    };
  }, [user]);

  return allowed;
}
